export default {
  en: {
    MaterialIndexScene: {
      title: 'Materials',
      addNew: 'Add new material',
    },
  },
};
